import * as React from 'react';
import harryBrainLogo from '@/components/ui/res/harry-brain-logo.png';
import harryBrainLogoBig from '@/components/ui/res/harry-logo.png';

/** Stable public URL — avoids broken avatars when content-hashed assets rotate after deploy. */
export const HARRY_AVATAR_SRC = '/harry-avatar.png';

export const Logo = () => (
  <img
    src={harryBrainLogo}
    alt="Harry Brain Logo"
    width={32}
    height={32}
  />
);

export const LogoBig = () => (
  <img
    src={harryBrainLogoBig}
    alt="Harry Brain Logo"
    width={192}
    height={192}
  />
);

export const GoogleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google</title>
    <path
      fill="#4285F4"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
    />
    <path
      fill="#EA4335"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
    />
  </svg>
);

export const AppleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Apple</title>
    <path
      fill="currentColor"
      d="M12.15,2.6a5.3,5.3,0,0,0-4.33,2.24A5.33,5.33,0,0,0,6,9.17c0,3.31,2.71,5.2,5,5.2a1.86,1.86,0,0,0,1.17-.41,1.57,1.57,0,0,0,.76-1.22,4.86,4.86,0,0,0-1.87-3.86,5.2,5.2,0,0,0-4.06-1.32,4.94,4.94,0,0,0-3.3,1.38,1.63,1.63,0,0,1-2.22.28,1.65,1.65,0,0,1-.28-2.23,8.13,8.13,0,0,1,5.48-2.24,8.38,8.38,0,0,1,6.23,2.82,8.1,8.1,0,0,1-2.36,11.62,8.2,8.2,0,0,1-10.45,1,1.65,1.65,0,0,1,.28-2.22,1.62,1.62,0,0,1,2.22-.29,4.92,4.92,0,0,0,6.3,0,4.83,4.83,0,0,0,1.39-3.33,4.5,4.5,0,0,0-1.71-3.41,1.64,1.64,0,0,1-.13-2.38,1.6,1.6,0,0,1,2.37-.14,8.13,8.13,0,0,1,2.94,6.1,8.33,8.33,0,0,1-3,6.1,8.19,8.19,0,0,1-6.1,3A8.34,8.34,0,0,1,3.8,17.2,8.12,8.12,0,0,1,7.82,4.84,5.3,5.3,0,0,1,12.15,2.6Z"
    />
  </svg>
);

export const HarryAvatar = () => (
  <img
    src={HARRY_AVATAR_SRC}
    alt="Harry"
    style={{ width: '50%', height: 'auto' }}
  />
);

export const BugIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m8 2 1.88 1.88" />
    <path d="M14.12 3.88 16 2" />
    <path d="M9 7.13v-1a3.003 3.003 0 1 1 6 0v1" />
    <path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6" />
    <path d="M12 20v-9" />
    <path d="M6.53 9C4.6 9 3 7.7 3 6" />
    <path d="M17.47 9c1.93 0 3.5-1.7 3.5-3" />
    <path d="M3 13h2" />
    <path d="M19 13h2" />
    <path d="m5 17 1.5-1.5" />
    <path d="m19 17-1.5-1.5" />
  </svg>
);

export const HeartIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7z" />
  </svg>
);
